import React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import EditSeller from './EditSeller';
import EditNoC from './EditNoc';
import EditProduct from './EditProduct';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import {
    Container,
    Box,
    Grid,
    Paper,
} from '@mui/material';
import PostAddIcon from '@mui/icons-material/PostAdd';

import Copyright from '../../components/Copyright'
import Title from '../../components/Title';
import DrawerMenu from '../../components/DrawerMenu';
import useStyles from '../../useStyles';
import TopBar from '../../components/TopBar';

export default function AddInfo() {
    const classes = useStyles();
    const [openSelect, setOpenSelect] = React.useState(false);
    const [selectedStore, setSelectedStore] = React.useState(null);

    var stores = JSON.parse(sessionStorage.getItem('stores'))
    stores = stores.map((el) => ({
        "store_id": el.id,
        "store_name": el.store_name
    }))

    const handleChange = (event) => {
        setSelectedStore(event.target.value);
    };

    const handleClose = () => {
        setOpenSelect(false);
    };

    const handleOpen = () => {
        setOpenSelect(true);
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <TopBar />
            <DrawerMenu />
            <main className={classes.content}>
                <div className={classes.appBarSpacer} />
                <Container maxWidth="lg" className={classes.container}>
                    <Grid container spacing={3} justifyContent={"flex-start"} direction="row">
                        <Grid item xs={12} md={12} lg={12}>
                            <Title><PostAddIcon />Editor</Title>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Grid container spacing={3} justifyContent={"center"} direction="column">
                                <Paper className={classes.paper}>
                                    <FormControl className={{ minWidth: 200, maxWidth: 200 }}>
                                        <InputLabel id="demo-controlled-open-select-label">  Loja  </InputLabel>
                                        <Select
                                            labelId="demo-controlled-open-select-label"
                                            id="demo-controlled-open-select"
                                            open={openSelect}
                                            onClose={handleClose}
                                            onOpen={handleOpen}
                                            value={selectedStore}
                                            onChange={handleChange}
                                        >
                                            {stores.map((store) => {
                                                return (
                                                    <MenuItem value={store.store_id}>{store.store_name}</MenuItem>
                                                )

                                            })}
                                        </Select>
                                    </FormControl>
                                </Paper>
                            </Grid>
                        </Grid>
                        {
                            (openSelect || !selectedStore) ?
                                null
                                :
                                <Grid container className={classes.container} spacing={3} justifyContent={"center"} direction="row">
                                    <Grid item xs={12} md={12} lg={6}>
                                        <EditSeller store={selectedStore} />
                                    </Grid>
                                    <Grid item xs={12} md={12} lg={6}>
                                        <EditNoC store={selectedStore} />
                                    </Grid>
                                    <Grid item xs={12} md={12} lg={6}>
                                        <EditProduct store={selectedStore} />
                                    </Grid>
                                </Grid>
                        }
                    </Grid>
                    <Box pt={4}>
                        <Copyright />
                    </Box>
                </Container>
            </main>
        </div>
    );
}